
	import { defineComponent } from 'vue'
	import SideBar from '@/common/components/SideBar.vue'
	import NavHeader from '@/common/components/NavHeader.vue'
	import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
	import moment from 'moment'
	import 'moment/locale/zh-cn'
	moment.locale('zh-cn')
	import { navLinks } from './config'
	export default defineComponent({
		components: {
			NavHeader,
			SideBar
		},
		data() {
			return {
				navLinks,
				zh_CN
			}
		}
	})
